import { UserInfo } from '@/a1/user/user-models';
import store from '@/store';

export class StoreService {
    setUser(userInfo: UserInfo) {
        store.commit('setUser', userInfo);
    }

    clearUser() {
        const userInfo: UserInfo = { id: "", username: "" };
        store.commit('setUser', userInfo);
    }

    get isAuthenticated() {
        return store.getters.isAuthenticated;
    }

    get username() {
        return store.getters.username;
    }
}

const storeService = new StoreService();
export default storeService;